import { useEffect, useState } from "react";

const ZONES = [
  { key: "local", label: "Local", tz: null, accent: "text-white" },
  { key: "utc",   label: "UTC",   tz: "UTC", accent: "text-cyan-400" },
  { key: "est",   label: "New York", tz: "America/New_York", accent: "text-[#F4D03F]" },
  { key: "sao",   label: "São Paulo", tz: "America/Sao_Paulo", accent: "text-[#00FFB2]" },
  { key: "lon",   label: "London",   tz: "Europe/London", accent: "text-[#B084FF]" },
  { key: "syd",   label: "Sydney",   tz: "Australia/Sydney", accent: "text-[#FF007F]" },
];

function formatTime(date, tz) {
  return date.toLocaleTimeString("en-GB", {
    timeZone: tz || undefined,
    hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
}
function formatDay(date, tz) {
  return date.toLocaleDateString("en-GB", {
    timeZone: tz || undefined,
    weekday: "short", month: "short", day: "numeric",
  });
}

export default function WorldClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      data-testid="world-clock"
      className="border border-[#232330] bg-[#101015] p-5 sm:p-6"
    >
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[10px] font-mono tracking-[0.3em] text-[#B084FF] uppercase">
            / GLOBAL COMMS
          </div>
          <div className="font-heading font-black uppercase tracking-tight text-lg sm:text-xl mt-1">
            Legacy World Clock
          </div>
        </div>
        <div className="text-[10px] font-mono uppercase tracking-widest text-gray-500 hidden sm:block">
          Live · updates every second
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {ZONES.map((z) => (
          <div
            key={z.key}
            data-testid={`clock-${z.key}`}
            className="border border-[#232330] bg-[#05050A] p-3"
          >
            <div className="text-[9px] font-mono uppercase tracking-widest text-gray-500">
              {z.label}
            </div>
            <div className={`font-heading font-black text-2xl md:text-3xl leading-none mt-2 tabular-nums ${z.accent}`}>
              {formatTime(now, z.tz)}
            </div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-gray-500 mt-2">
              {formatDay(now, z.tz)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
